<section id="wrapper" class="container content-wrapper">
    <article>
        <div class="row">
            <div class="col-xs-12 col-sm-6">
                <h1 class="headline">Sitemap</h1>
                <ul>
                    <li><a routerLink="/home" routerLinkActive="active">Home</a></li>
                    <li><a routerLink="/aboutme" routerLinkActive="active">Über mich</a></li>
                    <li><a routerLink="/photography" routerLinkActive="active">Fotografie</a></li>
                    <li>
                        <ul>
                            <li><a routerLink="/photography/architecture" routerLinkActive="active">Architektur</a></li>
                            <li><a routerLink="/photography/landscape" routerLinkActive="active">Landschaftsaufnahmen</a></li>
                            <li><a routerLink="/photography/sailing" routerLinkActive="active">Segeln</a></li>
                            <li><a routerLink="/photography/weltcup" routerLinkActive="active">Audi FIS Alpine Ski World Cup</a></li>
                            <li><a routerLink="/photography/local" routerLinkActive="active">Rund um München</a></li>
                            <li><a routerLink="/photography/event" routerLinkActive="active">Events</a></li>
                            <li><a routerLink="/photography/muenchner_sommernachtstraum" routerLinkActive="active">Münchner Sommernachtstraum</a></li>
                        </ul>
                    </li>
                    <li><a routerLink="/references" routerLinkActive="active">Referenzen</a></li>
                    <li><a routerLink="/impressum" routerLinkActive="active">Impressum</a></li>
                    <li><a routerLink="/contact" routerLinkActive="active">Kontakt</a></li>
                </ul>

            </div>
        </div>
    </article>
</section>
